export default __webpack_public_path__ + "static/media/placeholder_blank-nl-mobile.42f4a307.png";